import { render, staticRenderFns } from "./Especialidades.vue?vue&type=template&id=10a418ca&"
import script from "./Especialidades.vue?vue&type=script&lang=js&"
export * from "./Especialidades.vue?vue&type=script&lang=js&"
import style0 from "./Especialidades.vue?vue&type=style&index=0&id=10a418ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports